import { toast } from 'react-hot-toast';
import {
  UpdateCommunityReplyMutation,
  useUpdateCommunityReplyMutation,
} from 'generated/graphql';

type Options = {
  onCompleted?: (data: UpdateCommunityReplyMutation) => void;
};

export const useUpdateReply = ({ onCompleted }: Options = {}) =>
  useUpdateCommunityReplyMutation({
    onCompleted: (data) => {
      toast.success('Comment updated');
      onCompleted?.(data);
    },
    onError: () => toast.error('Something went wrong'),
  });
